// Shared floor plan data - Goldcrest Dreams Tower C
// Used by FloorPlans page and GoldcrestDreamTowerC

export const FLOOR_PLAN_ITEMS = [
	{
		name: '1 BHK+STUDY PLAN TYPE D',
		sqft: '1012.13 SQ. FT',
		features: ['1 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Study Room', 'Store', 'Hall', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 556,671.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 5,566.72',
		downPayment: '40% DOWN PAYMENT',
		imageKey: 'typed',
	},
	{
		name: '1 BHK+STUDY PLAN TYPE E',
		sqft: '1195.35 SQ. FT',
		features: ['1 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Study Room', 'Store', 'Hall', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 657,442.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 6,574.43',
		downPayment: '40% DOWN PAYMENT',
		imageKey: 'typee',
	},
	{
		name: '2 BHK PLAN TYPE A',
		sqft: '1234.25 SQ. FT',
		features: ['2 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Spacious Hall', 'Store', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 678,837.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 6,788.38',
		downPayment: '40% DOWN PAYMENT',
		imageKey: 'typea',
	},
	{
		name: '1 BHK PLAN TYPE B',
		sqft: '856.93 SQ. FT',
		features: ['1 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Hall', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 471,311.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 4,713.11',
		downPayment: '40% DOWN PAYMENT',
		imageKey: 'typeb',
	},
	{
		name: '1 BHK PLAN TYPE C',
		sqft: '909.85 SQ. FT',
		features: ['1 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Hall', 'Store', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 500,417.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 5,004.18',
		downPayment: '40% DOWN PAYMENT',
		imageKey: 'typec',
	},
];
